import React, { useState } from 'react';
import './Navbar.css';

const Navbar = ({ activePage, onNavigate }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleClick = (e, pageId) => {
    if (window.innerWidth > 900) {
      e.preventDefault();
      onNavigate(pageId);
    }
    setMenuOpen(false);
  };

  return (
    <nav className="navbar" aria-label="Main navigation">
      <a href="#home" className="navbar-logo" onClick={(e) => handleClick(e, 'home')}>
        <img src="/images/logo1.png" alt="AG Health Counseling logo" />
      </a>

      <button
        className="hamburger"
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
      >
        <span /><span /><span />
      </button>

      <ul className={`navbar-links ${menuOpen ? 'open' : ''}`}>
        {[
          { id: 'about',    label: 'About' },
          { id: 'services', label: 'Services' },
          { id: 'approach', label: 'Approach' },
          { id: 'fees',     label: 'Insurance' },
        ].map(({ id, label }) => (
          <li key={id}>
            <a
              href={`#${id}`}
              className={activePage === id ? 'nav-active' : ''}
              onClick={(e) => handleClick(e, id)}
            >
              {label}
            </a>
          </li>
        ))}
        <li>
          <a
            href="#contact"
            className={`nav-cta${activePage === 'contact' ? ' nav-cta--active' : ''}`}
            onClick={(e) => handleClick(e, 'contact')}
          >
            Book a Session
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;